import { FC } from 'react'

import { PeopleTable } from 'Pages/Employer/PeoplePage/PeopleTable/PeopleTable'
import { InviteUserModal } from 'Components/Modal/InviteUserModal/InviteUserModal'
import { ManageUserProgramsModal } from 'Components/Modal/ManageUserProgramsModal/ManageUserProgramsModal'
import { ManageUserPermissionsModal } from 'Components/Modal/ManageUserPermissionsModal/ManageUserPermissionsModal'
import { RemoveUserModal } from 'Components/Modal/RemoveUserModal/RemoveUserModal'
import { ReactivateUserModal } from 'Components/Modal/ReactivateUserModal/ReactivateUserModal'
import { ManageUserAllowancesModal } from 'Pages/JOONAdmin/EmployerDetailsPage/ManageUserAllowances/ManageUserAllowancesModal'
import { ManageUserInformationModal } from 'Components/Modal/ManageUserInformationModal/ManageUserInformationModal'
import { ManageUserRecurringAllowancesModal } from 'Pages/JOONAdmin/EmployerDetailsPage/ManageUserRecurringAllowances/ManageUserRecurringAllowancesModal'
import { UpdateUserCountryModal } from 'Components/Modal/UpdateUserCountryModal/UpdateUserCountryModal'
import { BulkUserManagementModal } from 'Components/Modal/BulkModal/BulkUserManagementModal'

import { useEmployerInfoContext } from 'Contexts/EmployerInfoContext'

import { useGetInvoicesQuery } from 'Hooks/api/employer/invoices/useGetInvoicesQuery'
import { ViewUserMembershipsModal } from 'Components/Modal/ViewUserMembershipsModal/ViewUserMembershipsModal'
import { BulkMetadataGridModal } from 'Components/Modal/BulkModal/BulkMetadataGridModal'
import { AddPurchaseForUserModal } from 'Pages/JOONAdmin/PeoplePage/AddPurchaseForUserModal'
import { BulkPurchaseUploadModal } from 'Components/Modal/BulkModal/BulkPurchaseUploadModal'

export const JoonAdminUsersTable: FC = () => {
  const {
    state: { employerId }
  } = useEmployerInfoContext()

  useGetInvoicesQuery({
    pageNumber: 1,
    employerId,
    perPage: 1
  })

  return (
    <>
      <PeopleTable isJoonAdmin />
      {/* Modals for managing users in various ways */}
      <InviteUserModal />
      <ManageUserProgramsModal />
      <ViewUserMembershipsModal />
      <ManageUserPermissionsModal />
      <ManageUserInformationModal isJoonAdmin />
      <BulkUserManagementModal />
      <BulkMetadataGridModal />
      <BulkPurchaseUploadModal />
      <RemoveUserModal />
      <ReactivateUserModal />
      <UpdateUserCountryModal />
      <ManageUserAllowancesModal />
      <ManageUserRecurringAllowancesModal />
      <AddPurchaseForUserModal />
    </>
  )
}
